export default __webpack_public_path__ + "static/media/empty_dashboard.4cc5ab64.png";